import React, { useEffect, useState } from 'react'
import { Link, useParams, useHistory } from 'react-router-dom'
import { useMsal } from "@azure/msal-react";
import useFetch from '../hooks/useFetch'
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import CategoryNavigation from '../components/CategoryNavigation';
import CategoryCard from '../components/CategoryCard';
import './category.css'

function Category() {
  const CATEGORY_MAPPING = {
    "Travel": "Travel",
    "Other Direct Costs": "Non-billable Expenses",
    "Reimbursable Expenses": "Billable Expenses",
    "Non-billable Expenses": "Non-billable Expenses",
    "Billable Expenses": "Billable Expenses",
  }
  const { instance, accounts } = useMsal();
  const name = accounts[0].name;
  const email = accounts[0].username;
  const history = useHistory();
  const { id } = useParams()
  const { loading, error, data } = useFetch('/api-dev/expenses/GetCategory/' + id, name, email)
  if (loading) return <div className='spinner'>
  <Box sx={{ display: 'flex' }} style={{margin:'40px',justifyContent:'center'}}>
    <CircularProgress />
  </Box> 
</div>;
  if (error) return <p>Error :(</p>
  const {info, categories} = data
  return (
    <div className='page-layout'>
      <CategoryNavigation taskID={info.TaskID} projectName={info.ProjectName} taskName={info.TaskName} projectID={info.ProjectID}/>
      <div className='category-container'>
        {categories.filter(category => CATEGORY_MAPPING[category.Category]).map((category) =>
          <CategoryCard taskID={info.TaskID} category={category} categoryName={CATEGORY_MAPPING[category.Category]} />
        )}
      </div>
    </div>
  )
}

export default Category